import { MyConversion } from "./conversion";

export const getFullCertificationName = (type, category) => {
  var myConversion = new MyConversion();
  return (
    myConversion.toCamelCase(type) + " " + myConversion.toCamelCase(category)
  );
};
